module.exports = __webpack_public_path__ + "img/Z71_16.17ccde7a.jpg";